import React, {useCallback, useEffect, useState} from 'react'
import {
    Box
    , Button
    , Divider
    , FormControl
    , IconButton
    , ImageList
    , ImageListItem
    , ImageListItemBar
    , InputAdornment
    , InputLabel
    , ListSubheader
    , MenuItem
    , Select
    , Stack
    , TextField
    , Tooltip
    , Typography, useTheme
} from '@mui/material'
import PhotoCamera from '@mui/icons-material/PhotoCamera'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import NoPhotographyIcon from '@mui/icons-material/NoPhotography'
import ImageIcon from '@mui/icons-material/Image'
import CollectionsIcon from '@mui/icons-material/Collections'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import DeleteIcon from '@mui/icons-material/Delete'
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import {tooltipClasses} from '@mui/material/Tooltip'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {
    MobileDateTimePicker,
    DateTimePicker,
    renderTimeViewClock,
    DatePicker,
    MobileDatePicker
} from '@mui/x-date-pickers/'
import {useFormContext, Controller} from 'react-hook-form'
// import moment from 'moment'
import dayjs from 'dayjs'
import CameraBox from '../Camera'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'
import ErrorBoundary from '../ErrorBoundary'
import useOnlineStatus from '../../hooks/useOnlineStatus'
import {grey} from '@mui/material/colors'
import SvgCustomIcon from "../icons/SvgCustomIcon";

const Form = ({
                  token
                  , isMobile
                  , submitRef
                  , form
                  , formModel
                  , formList
                  , formArray
                  , handleCrashSubmit
                  , isFilterForm
                  , images
                  , isReadOnly
              }) => {
    const {control, setValue, getValues, handleSubmit, watch, handlePicture} = useFormContext()
    const watchReportDate = watch('crash.Report date')
    const watchCrashDate = watch('crash.Crash date')
    const {_} = useLingui()
    const [isCameraOpen, setIsCameraOpen] = useState(false)
    const isOnline = useOnlineStatus()
    const theme = useTheme()
    const isDark = theme.mode === 'dark';

    const baseFieldSx = (theme, isDark) => ({
        backgroundColor: isDark ? theme.palette.newColors.lightGray : "#f5f5f5",
        color: isDark ? theme.palette.newColors.gray : "#3C3C3B",
        borderRadius: 1,
        "& label": {
            color: theme.palette.newColors.gray,
        },

        "& .MuiSelect-select": {
            color: isDark ? theme.palette.newColors.gray : "#3C3C3B",
        },
        '& .MuiOutlinedInput-root': {
            color: theme.palette.newColors.gray,
        },
        "& .MuiSelect-icon": {
            color: theme.palette.newColors.gray
        },
        "& fieldset": {border: "none"},
        "&:hover fieldset": {border: "none"},
        "&.Mui-focused fieldset": {border: "none"},
    });

    console.log(formArray, form.type)

    // const MemoDynForm = React.memo(DynamicForm)

    const getNewId = useCallback(date => {
        if (!isOnline) {
            setValue('crash.Crash id', 'Not Avail. offline')
            return
        }
        // eslint-disable-next-line no-restricted-globals
        const newCrashIdUrl = new URL('/api/crash/new_crash_id', location)
        newCrashIdUrl.searchParams.set('date', dayjs(date).format('YYYY-MM-DD'))

        fetch(newCrashIdUrl, {
            headers: {
                Authorization: `Bearer ${token}`
                , 'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(res => {
                setValue('crash.Crash id', res.crash_id) // Set the value of Crash id
            })
    }, [token, setValue, isOnline])

    useEffect(() => {
        if (!isFilterForm && form.type === 'crash') {
            if (!getValues('crash.Crash id')) {
                if (!watchReportDate) setValue('crash.Report date', dayjs())
                if (!watchCrashDate) setValue('crash.Crash date', dayjs())
                getNewId(watchCrashDate)
                setValue('isNew', true)
            } else if (!getValues('isNew')) {
                setValue('isModifying', true)
                setValue('isNew', false)
            }
        }
    }, [watchReportDate, watchCrashDate, isFilterForm, form.type, setValue, getValues, getNewId])

    // Handle file input change
    const handleFileChange = event => {
        const file = event.target.files[0]
        if (file) {
            // const imageUrl = URL.createObjectURL(file)
            const filereader = new FileReader()
            filereader.readAsDataURL(file)
            filereader.onload = evt => {
                const base64 = evt.target.result
                handlePicture(base64)
            }
        }
    }

    const handleCameraClose = () => {
        setIsCameraOpen(false)
    }

    const handleDownload = (base64Data, crashId, index) => {
        const link = document.createElement('a')
        const ext = base64Data.match(/^data:image\/(.*);base64,/)[1]
        link.href = base64Data
        link.download = `${crashId}_${index + 1}.${ext}`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    return (
        <Box
            name={form.type}
            component="form"
            ref={submitRef}
            onSubmit={handleSubmit(handleCrashSubmit)}
            display='flex'
            flexDirection='column'
            pl={1}
            pr={1}
            noValidate
        >
            {form.type === 'crash' && formModel.crash.elements
                .filter(element => element.label === 'Report date')
                .map(elem => ( // This gets filled automatically
                    <FormControl key={`crash-${elem.type}-${elem.label}`} margin={elem.margin || 'normal'}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Controller
                                name={'crash.Report date'}
                                control={control}
                                render={({field: {value, onChange}}) => {
                                    console.log('value ---- ', value)
                                    return (
                                        isMobile
                                            ? <MobileDatePicker
                                                label={elem.label}
                                                disableFuture
                                                readOnly={isReadOnly}
                                                slots={{openPickerIcon: SvgCustomIcon}}
                                                slotProps={{
                                                    openPickerIcon: {
                                                        name: "dateFrom",
                                                        color: theme.palette.newColors.gray
                                                    },
                                                    openPickerButton: {sx: {color: "#E0286C"}},
                                                }}
                                                value={value
                                                    ? dayjs(value)
                                                    : isFilterForm
                                                        ? null
                                                        : dayjs()
                                                }
                                                onAccept={date => {
                                                    onChange(date)
                                                }}
                                                sx={{marginTop: 1}}
                                            />
                                            : <DatePicker
                                                label={elem.label}
                                                disableFuture
                                                readOnly={isReadOnly}
                                                slots={{openPickerIcon: SvgCustomIcon}}
                                                slotProps={{
                                                    openPickerIcon: {
                                                        name: "dateFrom",
                                                        color: theme.palette.newColors.gray
                                                    },
                                                    textField: {sx: baseFieldSx(theme, isDark)},
                                                    openPickerButton: {sx: {color: "#E0286C"}},
                                                }}
                                                value={value
                                                    ? dayjs(value)
                                                    : isFilterForm
                                                        ? null
                                                        : dayjs()
                                                }
                                                onAccept={date => {
                                                    onChange(date)
                                                }}
                                                sx={{marginTop: 1}}
                                            />
                                    )
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>
                ))}

            {form.type === 'crash' && <Divider key='crash-divider' aria-hidden='true' sx={{margin: '1rem 0'}}/>}

            {form.type === 'crash' && formModel.crash.elements
                .filter(element => element.label === 'Crash id')
                .map(elem => ( // This gets filled automatically
                    <FormControl key={`crash-${elem.type}-${elem.label}`}>
                        <Controller
                            name={'crash.Crash id'}
                            control={control}
                            render={({field}) => (
                                <TextField
                                    sx={baseFieldSx(theme, isDark)}
                                    fullWidth
                                    margin={elem.margin || 'normal'}
                                    required={elem.isRequired}
                                    id={elem.label}
                                    label={elem.label}
                                    value={field.value}
                                    InputProps={{readOnly: true}}
                                    InputLabelProps={{shrink: true}}
                                    {...field}
                                />
                            )}
                        />
                    </FormControl>
                ))}

            {form.type === 'crash' && formModel.crash.elements
                .filter(element => element.label === 'Crash date')
                .map(elem => ( // This gets filled automatically
                    <FormControl key={`crash-${elem.type}-${elem.label}`} margin={elem.margin || 'normal'}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Controller
                                name={`crash.${elem.label}`}
                                control={control}
                                render={({field: {value, onChange}}) => (
                                    isMobile
                                        ? <MobileDateTimePicker
                                            slots={{openPickerIcon: SvgCustomIcon}}
                                            slotProps={{
                                                openPickerIcon: {
                                                    name: "dateFrom",
                                                    color: theme.palette.newColors.gray
                                                },
                                                textField: {sx: baseFieldSx(theme, isDark)},
                                                openPickerButton: {sx: {color: "#E0286C"}},
                                            }}
                                            label={elem.label}
                                            disableFuture
                                            readOnly={isReadOnly}
                                            value={value
                                                ? dayjs(value)
                                                : isFilterForm
                                                    ? null
                                                    : dayjs()
                                            }
                                            onAccept={date => {
                                                onChange(date)
                                            }}
                                            sx={{marginTop: 1}}
                                        />
                                        : <DateTimePicker
                                            slots={{openPickerIcon: SvgCustomIcon}}
                                            slotProps={{
                                                openPickerIcon: {
                                                    name: "dateFrom",
                                                    color: theme.palette.newColors.gray
                                                },
                                                textField: {sx: baseFieldSx(theme, isDark)},
                                                openPickerButton: {sx: {color: "#E0286C"}},
                                            }}
                                            label={elem.label}
                                            disableFuture
                                            readOnly={isReadOnly}
                                            value={value
                                                ? dayjs(value)
                                                : isFilterForm
                                                    ? null
                                                    : dayjs()
                                            }
                                            onAccept={date => {
                                                onChange(date)
                                            }}
                                            viewRenderers={{
                                                hours: renderTimeViewClock
                                                , minutes: renderTimeViewClock
                                                , seconds: renderTimeViewClock
                                            }}
                                            sx={{marginTop: 1}}
                                        />
                                )}
                            />
                        </LocalizationProvider>
                    </FormControl>
                ))}

            {form.type === 'crash' && formModel.crash.elements
                .filter(element => element.type === 'coordinates')
                .map(elem => ( // This gets filled automatically
                    <FormControl key={`crash-${elem.type}-${elem.label}`}>
                        <Controller
                            name={`crash.${elem.label}`}
                            control={control}
                            render={({field}) => (
                                <TextField
                                    sx={baseFieldSx(theme, isDark)}
                                    margin={elem.margin || 'normal'}
                                    fullWidth
                                    required={elem.isRequired}
                                    id={elem.label}
                                    label={elem.label}
                                    value={field.value}
                                    InputProps={{readOnly: true}}
                                    InputLabelProps={{shrink: true}}
                                    {...field}
                                />
                            )}
                        />
                    </FormControl>
                ))}

            {/* <MemoDynForm
        isMobile={isMobile}
        formModel={formModel}
        formList={formList}
        form={form}
        formArray={formArray}
        isReadOnly={isReadOnly}
      /> */}

            {formModel[form.type].elements
                .filter(elem => (elem.type !== 'coordinates' &&
                    elem.label !== 'Crash id' &&
                    elem.label !== 'Report date' &&
                    elem.label !== 'Crash date'
                ))
                .map(elem => {
                    if (elem.type === 'datetime') {
                        return (
                            <FormControl key={`${form.type}-${elem.type}-${elem.label}`}
                                         margin={elem.margin || 'normal'}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Controller
                                        name={`${formList[form.number]}.${elem.label}`}
                                        control={control}
                                        render={({field: {value, onChange}}) => (
                                            isMobile
                                                ? <MobileDateTimePicker
                                                    label={elem.label}
                                                    disableFuture
                                                    readOnly={isReadOnly}
                                                    value={value ? dayjs(value) : null}
                                                    onAccept={date => {
                                                        onChange(date)
                                                    }}
                                                    sx={{marginTop: 1}}
                                                />
                                                : <DateTimePicker
                                                    label={elem.label}
                                                    disableFuture
                                                    readOnly={isReadOnly}
                                                    value={value ? dayjs(value) : null}
                                                    onAccept={date => {
                                                        onChange(date)
                                                    }}
                                                    viewRenderers={{
                                                        hours: renderTimeViewClock
                                                        , minutes: renderTimeViewClock
                                                        , seconds: renderTimeViewClock
                                                    }}
                                                    sx={{marginTop: 1}}
                                                />
                                        )
                                        }
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        )
                    }

                    if (elem.type === 'date') {
                        return (
                            <FormControl key={`crash-${elem.type}-${elem.label}`} margin={elem.margin || 'normal'}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Controller
                                        name={`${formList[form.number]}.${elem.label}`}
                                        control={control}
                                        render={({field: {value, onChange}}) => (
                                            isMobile
                                                ? <MobileDatePicker
                                                    label={elem.label}
                                                    disableFuture
                                                    readOnly={isReadOnly}
                                                    defaultValue={value ? dayjs(value) : null}
                                                    onAccept={date => {
                                                        onChange(date)
                                                    }}
                                                    sx={{marginTop: 1}}
                                                />
                                                : <DatePicker
                                                    label={elem.label}
                                                    disableFuture
                                                    readOnly={isReadOnly}
                                                    defaultValue={value ? dayjs(value) : null}
                                                    onAccept={date => {
                                                        onChange(date)
                                                    }}
                                                    sx={{marginTop: 1}}
                                                />
                                        )}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        )
                    }

                    /* it could need to be unregistered */
                    // if (elem.type === 'divider') {
                    //   return (<Divider key={`${form.type}-${elem.type}`} aria-hidden='true' sx={{ margin: '1rem 0' }} />)
                    // }

                    if (elem.type === 'select') {
                        return (
                            <FormControl key={`${elem.type}-${elem.label}`} margin='normal'>
                                <InputLabel id={`select-${elem.label}`}>{elem.label}</InputLabel>
                                <Controller
                                    name={`${formList[form.number]}.${elem.label}`}
                                    control={control}
                                    render={({field}) => (
                                        // <Tooltip
                                        //   placement='right'
                                        //   title='ALL TOOLLTIIIPPPPPSSSSS'
                                        //   slotProps={{
                                        //     popper: {
                                        //       sx: {
                                        //         [`&.${tooltipClasses.popper} .${tooltipClasses.tooltip}`]:
                                        //           {
                                        //             marginLeft: 4
                                        //           }
                                        //       }
                                        //     }
                                        //   }}
                                        // >
                                        <Select
                                            {...field}
                                            labelId={`select-${elem.label}`}
                                            id={`select-${elem.label}`}
                                            sx={{
                                                ...baseFieldSx(theme, isDark),
                                                "&:hover": {backgroundColor: "inherit"}, // no hover white
                                            }}
                                            MenuProps={{
                                                sx: {
                                                    "& .MuiPaper-root": {
                                                        backgroundColor: isDark
                                                            ? theme.palette.newColors.lightGray
                                                            : "#f5f5f5",
                                                        color: isDark
                                                            ? theme.palette.newColors.gray
                                                            : "#3C3C3B",
                                                        boxShadow: isDark
                                                            ? "0 2px 8px rgba(0,0,0,0.4)"
                                                            : "0 2px 6px rgba(0,0,0,0.15)",
                                                    },
                                                },
                                            }}
                                            label={elem.label}
                                            value={field.value}
                                            disabled={isReadOnly}
                                            onChange={field.onChange}
                                            startAdornment={elem.unit &&
                                                <InputAdornment position='start'>{elem.unit}&nbsp;</InputAdornment>}
                                        >
                                            {elem.options.map(opt => {
                                                if (field.name.includes('Nationality') || field.name.includes('country')) {
                                                    return (
                                                        <MenuItem key={opt.label} value={opt.value}>
                                                            <Box display='flex'>
                                                                {opt.value !== 0 && <Box
                                                                    height='1.5rem'
                                                                    border='1px solid #c4c4c4'
                                                                    borderRadius={1}
                                                                    sx={{
                                                                        aspectRatio: '4/3'
                                                                        , backgroundImage: `url('${opt.flag}')`
                                                                        , backgroundSize: 'cover'
                                                                        , backgroundPosition: 'center center'
                                                                    }}
                                                                />}
                                                                <Typography
                                                                    ml={opt.value !== 0 ? 3 : 0}>{opt.label}</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    )
                                                } else {
                                                    return opt.value && opt.value % 100 === 0
                                                        ? <ListSubheader
                                                            key={`${opt.label}-sub`}>{opt.label}</ListSubheader>
                                                        : <MenuItem key={opt.label}
                                                                    value={opt.value}>{opt.label}</MenuItem>
                                                }
                                            })}
                                        </Select>
                                        // </Tooltip>
                                    )}
                                />
                            </FormControl>
                        )
                    }

                    return (
                        <FormControl key={`${elem.type}-${elem.label}`}>
                            <Controller
                                name={`${formList[form.number]}.${elem.label}`}
                                control={control}
                                render={({field}) => (
                                    <TextField
                                        {...field}
                                        margin={elem.margin || 'normal'}
                                        sx={baseFieldSx(theme, isDark)}
                                        fullWidth
                                        required={elem.isRequired}
                                        id={elem.label}
                                        label={elem.label}
                                        value={field.value}
                                        InputProps={{readOnly: isReadOnly}}
                                        onChange={field.onChange}
                                        slotProps={{
                                            input: {
                                                startAdornment: <InputAdornment
                                                    position='start'>{elem.unit}&nbsp;</InputAdornment>
                                            }
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    )
                })}

            {form.type === 'crash' &&
                <Stack direction='row' spacing={1} justifyContent={isMobile ? 'space-between' : 'center'}
                       sx={{mt: 1.5}}>
                    {/* Button for Library Upload */}
                    {!images?.length && !isReadOnly &&
                        <Button
                            fullWidth
                            sx={{background: theme.palette.newColors.cyanGradient,textTransform: 'none'}}
                            variant='contained'
                            component="label"
                            size={isMobile ? 'medium' : 'large'}
                            startIcon={<CollectionsIcon/>}
                        >
                            <Trans>Upload Pictures</Trans>
                            <input
                                type='file'
                                accept='image/*'
                                // capture='environment'
                                hidden
                                onChange={event => {
                                    // handleFileChange(event)
                                    const files = event.target.files
                                    if (files.length) {
                                        [...files].forEach(file => {
                                            const filereader = new FileReader()
                                            filereader.readAsDataURL(file)
                                            // eslint-disable-next-line no-loop-func
                                            filereader.onload = evt => {
                                                const base64 = evt.target.result
                                                handlePicture(base64)
                                            }
                                        })
                                    }
                                }}
                            />
                        </Button>
                    }
                    {isMobile &&
                        <Button
                            fullWidth
                            variant='contained'
                            disabled={isReadOnly}
                            // component="label"
                            size='medium'
                            startIcon={<PhotoCamera/>}
                            onClick={() => {
                                setIsCameraOpen(true)
                            }}
                        >
                            <Trans>Take Picture</Trans>
                        </Button>
                    }
                </Stack>
            }
            {/* <SwipeableDrawer
        anchor='bottom'
        open={isCameraOpen}
        onClose={handleCameraClose}
        // onOpen={toggleDrawer(anchor, true)}
      >
        <CameraBox
          handlePicture={handlePicture}
          handleCameraClose={handleCameraClose}
        />
      </SwipeableDrawer> */}
            {isCameraOpen &&
                <ErrorBoundary>
                    <CameraBox
                        handlePicture={handlePicture}
                        handleCameraClose={handleCameraClose}
                    />
                </ErrorBoundary>
            }
            {/* Display the selected image */}
            {form.type === 'crash' && !!images?.length &&
                <ImageList sx={{width: '100%'}}>
                    {images.map((image, index) => (
                        <ImageListItem key={index}>
                            <img
                                srcSet={image}
                                src={image}
                                alt={image}
                                loading="lazy"
                            />
                            <ImageListItemBar
                                title={index + 1}
                                actionIcon={
                                    <Box>
                                        <IconButton
                                            // disabled={isReadOnly}
                                            sx={{color: 'rgba(255, 255, 255, 0.54)'}}
                                            aria-label={_(msg`download picture no ${index}`)}
                                            onClick={() => handleDownload(image, getValues('crash.Crash id'), index)}
                                        >
                                            {/* <DownloadRoundedIcon color={isReadOnly ? 'disabled' : grey['400'] } /> */}
                                            <DownloadRoundedIcon color={grey['400']}/>
                                        </IconButton>
                                        <IconButton
                                            disabled={isReadOnly}
                                            sx={{color: 'rgba(255, 255, 255, 0.54)'}}
                                            aria-label={_(msg`delete picture no ${index}`)}
                                            onClick={() => handlePicture(null, index)}
                                        >
                                            <SvgCustomIcon name={'delete'} color={theme.palette.newColors.gray}/>
                                        </IconButton>
                                    </Box>
                                }
                            />
                        </ImageListItem>
                    ))}
                    {!isReadOnly &&
                        <Button
                            fullWidth
                            variant='contained'
                            sx={{background: theme.palette.newColors.cyanGradient,textTransform: 'none'}}
                            component="label"
                            size={isMobile ? 'medium' : 'large'}
                        >
                            <SvgCustomIcon name={'plus'} color={'white'}/>
                            <input
                                type='file'
                                accept='image/*'
                                // capture='environment'
                                hidden
                                onChange={event => {
                                    // handleFileChange(event)
                                    const files = event.target.files
                                    if (files.length) {
                                        [...files].forEach(file => {
                                            const filereader = new FileReader()
                                            filereader.readAsDataURL(file)
                                            // eslint-disable-next-line no-loop-func
                                            filereader.onload = evt => {
                                                const base64 = evt.target.result
                                                handlePicture(base64)
                                            }
                                        })
                                    }
                                }}
                            />
                        </Button>}
                </ImageList>
            }
        </Box>
    )
}

export default Form

// import CameraAltIcon from '@mui/icons-material/CameraAlt';
// import ReactWebcam from 'react-webcam';

// const CameraUpload = () => {
//   const { control, handleSubmit, reset } = useForm();
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isWebcamOpen, setIsWebcamOpen] = useState(false);
//   const webcamRef = useRef(null);

//   // Handle file input change
//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageUrl = URL.createObjectURL(file);
//       setSelectedImage(imageUrl);
//     }
//   };

//   // Capture photo from webcam
//   const capturePhoto = () => {
//     const imageSrc = webcamRef.current.getScreenshot();
//     setSelectedImage(imageSrc);
//     setIsWebcamOpen(false);
//   };

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <Stack direction="column" spacing={3} alignItems="center">
//         {/* Webcam Toggle Button */}
//         <Button
//           variant="contained"
//           onClick={() => setIsWebcamOpen(!isWebcamOpen)}
//           startIcon={<CameraAltIcon />}
//         >
//           {isWebcamOpen ? 'Close Camera' : 'Open Camera'}
//         </Button>

//         {/* Webcam Capture */}
//         {isWebcamOpen && (
//           <Box sx={{ marginBottom: 2 }}>
//             <ReactWebcam
//               audio={false}
//               ref={webcamRef}
//               screenshotFormat="image/jpeg"
//               width={300}
//               videoConstraints={{ facingMode: 'environment' }}
//             />
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={capturePhoto}
//               sx={{ marginTop: 2 }}
//             >
//               Capture Photo
//             </Button>
//           </Box>
//         )}

//         <Divider sx={{ width: '100%', marginY: 2 }} />

//         {/* File Upload Button */}
//         <Controller
//           name="image"
//           control={control}
//           render={({ field }) => (
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<PhotoCamera />}
//             >
//               Upload from Device
//               <input
//                 {...field}
//                 type="file"
//                 accept="image/*"
//                 hidden
//                 onChange={(event) => {
//                   handleFileChange(event);
//                   field.onChange(event.target.files);
//                 }}
//               />
//             </Button>
//           )}
//         />

//         {/* Optional Icon Button */}
//         <Controller
//           name="imageIconUpload"
//           control={control}
//           render={({ field }) => (
//             <IconButton
//               color="primary"
//               component="label"
//               aria-label="upload picture"
//             >
//               <UploadFileIcon />
//               <input
//                 {...field}
//                 type="file"
//                 accept="image/*"
//                 hidden
//                 onChange={(event) => {
//                   handleFileChange(event);
//                   field.onChange(event.target.files);
//                 }}
//               />
//             </IconButton>
//           )}
//         />

//         {/* Submit Button */}
//         <Button type="submit" variant="contained" color="success">
//           Submit
//         </Button>

//         {/* Reset Button */}
//         <Button
//           variant="outlined"
//           color="secondary"
//           onClick={() => {
//             reset();
//             setSelectedImage(null);
//           }}
//         >
//           Reset
//         </Button>

//         {/* Display the selected image */}
//         {selectedImage && (
//           <Box mt={3}>
//             <Typography variant="h6">Selected Image:</Typography>
//             <img
//               src={selectedImage}
//               alt="Selected"
//               style={{ width: '100%', maxWidth: '300px', borderRadius: '8px' }}
//             />
//           </Box>
//         )}
//       </Stack>
//     </form>
//   );
// };

// export default CameraUpload;
